
    import './styles.scoped.css';
    export default {
  "header-cell": "awsui_header-cell_1spae_9syim_93",
  "header-cell-sticky": "awsui_header-cell-sticky_1spae_9syim_105",
  "header-cell-stuck": "awsui_header-cell-stuck_1spae_9syim_108",
  "header-cell-variant-full-page": "awsui_header-cell-variant-full-page_1spae_9syim_108",
  "header-cell-hidden": "awsui_header-cell-hidden_1spae_9syim_111",
  "header-cell-sortable": "awsui_header-cell-sortable_1spae_9syim_114",
  "sticky-cell": "awsui_sticky-cell_1spae_9syim_117",
  "sticky-cell-pad-left": "awsui_sticky-cell-pad-left_1spae_9syim_125",
  "has-selection": "awsui_has-selection_1spae_9syim_125",
  "sticky-cell-last-left": "awsui_sticky-cell-last-left_1spae_9syim_128",
  "header-cell-resizable": "awsui_header-cell-resizable_1spae_9syim_132",
  "sticky-cell-last-right": "awsui_sticky-cell-last-right_1spae_9syim_135",
  "sorting-icon": "awsui_sorting-icon_1spae_9syim_165",
  "edit-icon": "awsui_edit-icon_1spae_9syim_173",
  "header-cell-content": "awsui_header-cell-content_1spae_9syim_179",
  "header-cell-fake-focus": "awsui_header-cell-fake-focus_1spae_9syim_208",
  "header-cell-disabled": "awsui_header-cell-disabled_1spae_9syim_226",
  "header-cell-sorted": "awsui_header-cell-sorted_1spae_9syim_226",
  "header-cell-text": "awsui_header-cell-text_1spae_9syim_240",
  "header-cell-text-wrap": "awsui_header-cell-text-wrap_1spae_9syim_245",
  "header-cell-ascending": "awsui_header-cell-ascending_1spae_9syim_251",
  "header-cell-descending": "awsui_header-cell-descending_1spae_9syim_252",
  "is-visual-refresh": "awsui_is-visual-refresh_1spae_9syim_262",
  "has-striped-rows": "awsui_has-striped-rows_1spae_9syim_273"
};
  